import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { BulletinCityVM, BulletinSchoolVM, BulletinVM } from 'app/bulletin/bulletin';
import { ToolsService } from './tools.service';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
    }),
};

@Injectable({ providedIn: 'root' })
export class BulletinService {
    baseUrl: string = '';
    apiUrl: string = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') apiUrl: string, private toolsService: ToolsService) {
        this.apiUrl = apiUrl;
        this.baseUrl = `${apiUrl}` + 'api/Bulletins';
    }

    getBulletins(): Observable<BulletinVM[]> {
        return this.http.get<BulletinVM[]>(this.baseUrl);
    }

    getBulletinById(id: number): Observable<BulletinVM> {
        return this.http.get<BulletinVM>(`${this.baseUrl}/${id}`);
    }

    createBulletin(params: BulletinVM): Observable<BulletinVM> {
        return this.http.post<any>(this.baseUrl, params, httpOptions);
    }

    updateBulletin(id: number, bulletin: BulletinVM): Observable<any> {
        return this.http.put<BulletinVM>(`${this.baseUrl}/${id}`, bulletin);
    }

    deleteBulletin(id: number): Observable<BulletinVM> {
        return this.http.delete<BulletinVM>(`${this.baseUrl}/${id}`);
    }

    getLatestBulletin(schoolNumber = ''): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}` + 'api/Bulletins/latest');
    }

    getDistinctCities(): Observable<BulletinCityVM[]> {
        return this.http.get<BulletinCityVM[]>(this.baseUrl + '/cities');
    }

    getBulletinsSchools(): Observable<BulletinSchoolVM[]> {
        return this.http.get<BulletinSchoolVM[]>(this.baseUrl + '/schools');
    }

    isBulletinLive(bulletin): boolean {
        const DateNow = this.toolsService.toISOLocal(new Date());
        return  DateNow > bulletin.startDate && DateNow < bulletin.endDate && bulletin.active;
    }

    getLatestBulletinFromAPI(schoolNumber = ''): Observable<any> {
        let HTTPOptions: Object = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            params: {schoolNumber},
            responseType: 'text'
         }
        return this.http.get<any>(`${this.apiUrl}api/bulletinapi`, HTTPOptions);
    }

}
